import type {
  BanksData,
  DepositSelectOption,
  DepositType,
  DepositWithdrawAssets,
} from '@/shared/types';
import type { AssetsIcons } from '@/shared/api';

export function getDepositFiatCurrencyInputOptions(
  depositType: DepositType,
  data?: DepositWithdrawAssets,
  assetsIconsData?: AssetsIcons,
  banksData?: BanksData,
  bankCountryCode?: string
): DepositSelectOption[] {
  if (!data?.deposit?.fiat || !assetsIconsData) {
    return [];
  }

  const fiatData = data.deposit.fiat.find(
    f => Object.keys(f)[0] === depositType
  );

  const currencyGroup = fiatData
    ? fiatData[depositType as keyof DepositType]
    : [];

  if (depositType === 'bank') {
    if (!banksData || !bankCountryCode) {
      return [];
    }

    const selectedCountry = banksData.deposit.countries.find(
      c => c.countryCode === bankCountryCode
    );

    if (!selectedCountry?.currencies) {
      return [];
    }

    const currencyMap = new Map(currencyGroup.map(c => [c.code, c]));

    return selectedCountry.currencies.map(countryBankCurrency => ({
      value: countryBankCurrency.code,
      label: countryBankCurrency.code,
      name: countryBankCurrency.name,
      icon: assetsIconsData[countryBankCurrency.code] || '',
      min: currencyMap.get(countryBankCurrency.code)?.min || 0,
    }));
  }

  const currencyNameMap = new Map<string, string>();

  if (banksData?.deposit) {
    const relevantCountries = bankCountryCode
      ? banksData.deposit.countries.filter(
          c => c.countryCode === bankCountryCode
        )
      : banksData.deposit.countries;

    for (const country of relevantCountries) {
      for (const currency of country.currencies) {
        if (!currencyNameMap.has(currency.code)) {
          currencyNameMap.set(currency.code, currency.name);
        }
      }
    }
  }

  return currencyGroup.map(currency => ({
    value: currency.code,
    label: currency.code,
    name: currencyNameMap.get(currency.code) || '',
    min: currency.min,
    icon: assetsIconsData[currency.code] || '',
  }));
}
